// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { State } from './IssueType.types.tsx';

export const clearIssueTypesStore =
	() =>
	({ setState }: StoreActionApi<State>): void => {
		setState({
			issueTypesById: {},
			issueTypesByProjectId: {},
		});
	};
